import { breakpointSizes, getBreakpointDown } from '@paywithextend/components'
import { base_colorRaisedSurface, grey400 } from 'ext-ui/style/colors'
import { css } from 'styled-components'

export default css`
  display: grid;
  grid-template-columns: 50% 50%;

  // border on CMS content between CMS content and signin content
  & > *:last-child {
    border: none;
    border-left: 1px solid ${grey400};
  }

  // Hide the CMS on smaller screens
  @media (max-width: 768px) {
    grid-template-columns: 1fr;

    & > *:last-child {
      display: none;
    }
  }
`

export const halfPageStyling = css`
  background-color: ${base_colorRaisedSurface};
  display: flex;
  align-items: stretch;
  justify-content: center;
  width: 100%;
  gap: 60px;

  ${getBreakpointDown(breakpointSizes.MD)(css`
    padding: 0px;
  `)}

  .unauthedBoxContainer {
    display: flex;
    flex-direction: column;
    padding: 80px 0;
    justify-content: center;

    ${getBreakpointDown(breakpointSizes.MD)(css`
      width: 100%;
      align-items: center;
      padding: 40px 10px;
    `)}
  }

  .signinForm {
    min-width: 300px;
    ${getBreakpointDown(breakpointSizes.XSM)(css`
      min-width: auto;
    `)}
  }
`

export const boxStyling = css`
  background-color: unset;
  box-shadow: none;

  ${getBreakpointDown(breakpointSizes.SM)(css`
    width: 100%;
    padding: 60px 20px;
  `)}
`
